import React from 'react';

const ViewSwitcher = ({ activeView, setActiveView }) => {
  const buttonStyle = (view) => ({
    display: 'None',
    padding: '8px 16px',
    fontSize: '12px',
    border: 'none',
    cursor: 'pointer',
    backgroundColor: activeView === view ? '#1976d2' : '#e0e0e0',
    color: activeView === view ? 'white' : 'black',
    fontWeight: activeView === view ? 'bold' : 'normal',
    transition: 'background-color 0.3s ease',
  });

  return (
    <div style={{ display: 'flex', marginBottom: '10px', width: '100%', boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
      <button 
        style={{ ...buttonStyle('painel1'), borderTopLeftRadius: '4px', borderBottomLeftRadius: '4px' }} 
        onClick={() => setActiveView('painel1')}
      > 
        Painel Principal
      </button>

    </div>
  );
};

export default ViewSwitcher;